import { Button, Col, DatePicker, Form, Row, Typography } from 'antd';
import BieuDo from 'components/bieuDo';
import FillterTable from 'components/FillterTable';
import { PopUpAddGraphical } from 'components/popupAddGraphical';
import RenderForm from 'components/renderForm';
import TablePagination from 'components/TablePagination';
import dayjs from 'dayjs';
import { exportTableToExcelNew } from 'helpers';
import { ConverData, ConverDataName } from 'helpers/dataToAntdSelect';
import { rangePresets } from 'helpers/helpersDatePicker';
import { useEffect, useMemo, useState } from 'react';
import { useQueries } from 'react-query';
import {
    getApiNames,
    getHours,
    getPackageDurations,
    getPaymentChannels,
    getServicePackages,
    getServices,
    getStatusCodes,
} from 'services/apiRequest';
import { getDataDangKyDichVu, getGraphicalDangKyDichVu } from 'services/dangKyDichVu';

const DIMENSION_ID = 15;
const METRIC_ID = 15;

export default function ThongKeDangKyDichVu() {
    const [form] = Form.useForm();

    const [tableFields, setTableFields] = useState({ metricIds: [1], dimensionIds: [1] });

    const [
        { data: dataServices },
        { data: dataServicePackages },
        { data: dataPaymentChannels },
        { data: dataPackageDurations },
    ] = useQueries([
        {
            queryKey: ['dataServices'],
            queryFn: () => getServices(),
        },
        {
            queryKey: ['dataServicePackages'],
            queryFn: () => getServicePackages(),
        },
        {
            queryKey: ['dataPaymentChannels'],
            queryFn: () => getPaymentChannels(),
        },
        {
            queryKey: ['dataPackageDurations'],
            queryFn: () => getPackageDurations(),
        },
    ]);
    const [dataExport, setDataExport] = useState(null);

    const [graphical, setGraphical] = useState(null);

    const watchForm = Form.useWatch([], form);
    const listGoiDichVu = useMemo(() => {
        if (!watchForm) {
            return dataServicePackages?.data;
        }

        const { serviceIds, premiumTypeIds } = watchForm;

        if (serviceIds?.length == 0) {
            return dataServicePackages?.data;
        }

        const dataCompare = [...dataServicePackages?.data];

        const data = dataCompare.filter((item) => serviceIds.includes(+item.service_id));

        const idServicePackageIds = data.map((item) => +item.id);

        // Kiểm tra phần tử trong idServicePackageIds không thuộc trong data và không phải 0
        const invalidIds = premiumTypeIds.filter((item) => !idServicePackageIds.includes(item));

        const hasInvalidIds = invalidIds.length > 0; // Kiểm tra nếu có id không hợp lệ

        if (hasInvalidIds) {
            form.setFieldValue('premiumTypeIds', []);
        }

        return data;
    }, [watchForm?.serviceIds]);
    const setUpFormModal = [
        {
            name: 'serviceIds',
            type: 'select',
            lg: 6,
            propsInput: {
                showSearch: true,
                allowClear: true,
                mode: 'multiple',
            },
            label: 'Dịch vụ',
            options: ConverData(dataServices?.data || []),
        },
        {
            name: 'premiumTypeIds',
            type: 'select',
            lg: 6,
            propsInput: {
                showSearch: true,
                allowClear: true,
                mode: 'multiple',
            },
            label: 'Gói dịch vụ',
            options: ConverData(listGoiDichVu || dataServicePackages?.data || []),
        },
        {
            name: 'packageDurationIds',
            type: 'select',
            lg: 6,
            propsInput: {
                showSearch: true,
                allowClear: true,
                mode: 'multiple',
            },
            label: 'Chu kỳ gói',
            options: ConverData(dataPackageDurations?.data || []),
        },
        {
            name: 'paymentChannelIds',
            type: 'select',
            lg: 6,
            propsInput: {
                showSearch: true,
                allowClear: true,
                mode: 'multiple',
            },
            label: 'Kênh thanh toán',
            options: ConverData(dataPaymentChannels?.data || []),
        },
        {
            name: 'isAutoRenew',
            type: 'select',
            lg: 6,
            propsInput: {
                showSearch: true,
                allowClear: true,
                mode: 'multiple',
            },
            label: 'Tự động gia hạn',
            options: [
                { label: 'Không', value: 'Không' },
                { label: 'Có', value: 'Có' },
            ],
        },
        {
            name: 'range-time-expiration',
            type: 'range-picker',
            lg: 6,
            propsInput: {
                format: 'DD/MM/YYYY',
                presets: rangePresets,
                // showSearch: true,
                // allowClear: true
            },
            label: 'Khoảng thời gian ngày hết hạn',
        },
        {
            name: 'range-time-latest-renew',
            type: 'range-picker',
            lg: 6,
            propsInput: {
                format: 'DD/MM/YYYY',
                presets: rangePresets,
                // showSearch: true,
                // allowClear: true
            },
            label: 'Khoảng thời gian ngày gia hạn gần nhất',
        },
        {
            name: 'range-time-start',
            type: 'range-picker',
            lg: 6,
            propsInput: {
                format: 'DD/MM/YYYY',
                presets: rangePresets,
                // showSearch: true,
                // allowClear: true
            },
            label: 'Khoảng thời gian ngày bắt đầu',
        },
        {
            type: 'html',
            lg: 6,
            content: (
                <Row className={'w-full flex gap-x-2 justify-start items-end content-end h-full'}>
                    {/* <Typography.Text>
                        Thời gian cập nhật dữ liệu :12/12/2022
                    </Typography.Text>
                    <Button
                        color="danger"
                    >
                        Cập nhật dữ liệu mới
                    </Button> */}
                    <Button
                        type="primary"
                        onClick={() => {
                            form.submit();
                        }}
                    >
                        Áp dụng
                    </Button>
                </Row>
            ),
        },
    ];

    const [whereCondition, setWhereCondition] = useState({
        expirationFilterStartTime: dayjs().format('DD/MM/YYYY'),
        expirationFilterEndTime: dayjs('2150-12-31').format('DD/MM/YYYY'),
        startFilterStartTime: null,
        startFilterEndTime: null,
        latestRenewFilterStartTime: null,
        latestRenewFilterEndTime: null,
        premiumTypeIds: [],
        serviceIds: [],
        packageDurationIds: [],
        paymentChannelIds: [],
        isAutoRenew: [],
    });

    useEffect(() => {
        let initialValues = Object.assign({}, whereCondition);

        const expirationFilterStartTime = dayjs(
            initialValues.expirationFilterStartTime,
            'DD/MM/YYYY'
        ).isValid()
            ? dayjs(initialValues.expirationFilterStartTime, 'DD/MM/YYYY')
            : null;
        const expirationFilterEndTime = dayjs(
            initialValues.expirationFilterEndTime,
            'DD/MM/YYYY'
        ).isValid()
            ? dayjs(initialValues.expirationFilterEndTime, 'DD/MM/YYYY')
            : null;

        initialValues['range-time-expiration'] = [
            expirationFilterStartTime,
            expirationFilterEndTime,
        ];

        const startFilterStartTime = dayjs(
            initialValues.startFilterStartTime,
            'DD/MM/YYYY'
        ).isValid()
            ? dayjs(initialValues.expirationFilterStartTime, 'DD/MM/YYYY')
            : null;
        const startFilterEndTime = dayjs(initialValues.startFilterEndTime, 'DD/MM/YYYY').isValid()
            ? dayjs(initialValues.startFilterEndTime, 'DD/MM/YYYY')
            : null;

        initialValues['range-time-start'] = [startFilterStartTime, startFilterEndTime];

        const latestRenewFilterStartTime = dayjs(
            initialValues.latestRenewFilterStartTime,
            'DD/MM/YYYY'
        ).isValid()
            ? dayjs(initialValues.latestRenewFilterStartTime, 'DD/MM/YYYY')
            : null;
        const latestRenewFilterEndTime = dayjs(
            initialValues.latestRenewFilterEndTime,
            'DD/MM/YYYY'
        ).isValid()
            ? dayjs(initialValues.latestRenewFilterEndTime, 'DD/MM/YYYY')
            : null;

        initialValues['range-time-latest-renew'] = [
            latestRenewFilterStartTime,
            latestRenewFilterEndTime,
        ];

        form.setFieldsValue(initialValues);
    }, []);

    return (
        <div className="px-7">
            <div className="flex flex-col gap-5 p-7 card">
                <div className="flex items-center justify-items-center justify-between">
                    <h1>
                        <b>THỐNG KÊ ĐĂNG KÝ DỊCH VỤ</b>
                    </h1>

                    <div className="flex justify-content-end gap-3">
                        <Button
                            type="primary"
                            onClick={() => {
                                exportTableToExcelNew(dataExport, 'BaoCaoTruyCapApi');
                            }}
                        >
                            Export
                        </Button>
                        {/* <PopUpAddGraphical
                            metricId={METRIC_ID}
                            dimensionId={DIMENSION_ID}
                            addDataFields={(values) => {
                                const newValues = { ...values };
                                setGraphical(newValues);
                            }}
                        /> */}
                    </div>
                </div>

                <RenderForm
                    onFinish={(values) => {
                        let dataQueries = {};

                        Object.keys(values).map((key) => {
                            const item = values[key];
                            if (key == 'range-time-expiration') {
                                if (item) {
                                    const expirationFilterStartTime = item[0]
                                        ? dayjs(item[0]).format('DD/MM/YYYY')
                                        : null;
                                    const expirationFilterEndTime = item[1]
                                        ? dayjs(item[1]).format('DD/MM/YYYY')
                                        : null;

                                    dataQueries.expirationFilterStartTime =
                                        expirationFilterStartTime;
                                    dataQueries.expirationFilterEndTime = expirationFilterEndTime;
                                }
                            } else if (key == 'range-time-start') {
                                if (item) {
                                    const startFilterStartTime = item[0]
                                        ? dayjs(item[0]).format('DD/MM/YYYY')
                                        : null;
                                    const startFilterEndTime = item[1]
                                        ? dayjs(item[1]).format('DD/MM/YYYY')
                                        : null;

                                    dataQueries.startFilterStartTime = startFilterStartTime;
                                    dataQueries.startFilterEndTime = startFilterEndTime;
                                }
                            } else if (key == 'range-time-latest-renew') {
                                if (item) {
                                    const latestRenewFilterStartTime = item[0]
                                        ? dayjs(item[0]).format('DD/MM/YYYY')
                                        : null;
                                    const latestRenewFilterEndTime = item[1]
                                        ? dayjs(item[1]).format('DD/MM/YYYY')
                                        : null;

                                    dataQueries.latestRenewFilterStartTime =
                                        latestRenewFilterStartTime;
                                    dataQueries.latestRenewFilterEndTime = latestRenewFilterEndTime;
                                }
                            } else if (key == 'audienceIds') {
                                if (item) {
                                    dataQueries[key] = [item];
                                } else {
                                    dataQueries[key] = [];
                                }
                            } else {
                                if (item) {
                                    dataQueries[key] = item;
                                } else {
                                    dataQueries[key] = [];
                                }
                            }
                        });

                        setWhereCondition(dataQueries);
                    }}
                    form={form}
                    fields={setUpFormModal}
                    footer={<></>}
                />

                {/* <BieuDo
                    metricId={METRIC_ID}
                    dimensionId={DIMENSION_ID}
                    whereCondition={whereCondition}
                    apiCallBack={getGraphicalDangKyDichVu}
                    dataFields={[{ metricIds: [1], dimensionIds: [null] }]}
                    addGraphical={graphical}
                /> */}

                <div className="flex w-full">
                    <Row className="w-full" justify="space-between" gutter={[10, 10]}>
                        <Col span={20}>
                            <TablePagination
                                apiCallBack={getDataDangKyDichVu}
                                whereCondition={whereCondition}
                                dataFields={tableFields}
                                dataTableChange={(values) => {
                                    setDataExport(values);
                                }}
                            />
                        </Col>
                        <Col span={4}>
                            <FillterTable
                                metricId={METRIC_ID}
                                dimensionId={DIMENSION_ID}
                                dataFields={tableFields}
                                onFieldsChange={(values) => {
                                    setTableFields(values);
                                }}
                            />
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    );
}
